export default __webpack_public_path__ + "static/media/termRiseDark.bb4149a2.svg";